import { Modal, Button } from 'antd';

interface RosterDeleteConfirmationModalProps {
  open: boolean;
  handleCloseDelete: () => void;
  handleDelete: () => void;
  deleteMessage: string;
  contentChange?: boolean;
  loading?: boolean;
}

const RosterDeleteConfirmationModal = (props: RosterDeleteConfirmationModalProps) => {
  const { contentChange = false, open, handleCloseDelete, handleDelete, deleteMessage, loading = false } = props;

  return (
    <Modal
      title={`${contentChange ? 'Note' : 'Delete Confirmation'}`}
      centered
      open={open}
      footer={null}
      maskClosable={false}
      onCancel={handleCloseDelete}
    >
      <div className='pt-4'>{deleteMessage}</div>
      <div className='mt-5 flex justify-end '>
        {!contentChange && (
          <button
            className='addButton mr-4 secondary'
            onClick={handleCloseDelete}
          >
            Cancel
          </button>
        )}
        <Button
          className='addButton mr-4 '
          onClick={() => {
            handleDelete();
          }}
          loading={loading}
        >
          {`${contentChange ? 'Ok' : 'Delete'}`}
        </Button>
      </div>
    </Modal>
  );
};

export default RosterDeleteConfirmationModal;
